$(document).ready(function(){

	// -- slider default (slider__banners, slider__gallery) --
	const sliderDefault = $('.slider__default');
	sliderDefault.each(function(index,value) {
		const sliderDefaultSettings = {
			'slide': '.slick-slide',
			'infinite': false,
		  'autoplay': true,
  		'autoplaySpeed': 5000,
		  'arrows': true,
		  'prevArrow': $(this).next('.slider__nav').find('.prev__slide'),
		  'nextArrow': $(this).next('.slider__nav').find('.next__slide'),
		  'pauseOnFocus': false,
		  'pauseOnHover': false,
		};
	  $(this).slick(sliderDefaultSettings);
	});

	// -- slider interactiveMap --
	const sliderInteractiveMapImages = $('.slider__interactiveMap__images');
	sliderInteractiveMapImages.each(function(index,value) {
		const sliderInteractiveMapImagesSettings = {
			'slide': '.slick-slide',
			'infinite': false,
		  'arrows': false,
		  'dots': false,
			'fade': true,
			// 'asNavFor': '.slider__interactiveMap__nav',
		};
		$(this).parents('.blockInteractiveMap').find('.slider__interactiveMap__nav button').on('click', function(e){
			var getIndex = $(this).attr('data-index');
			var getSlider = $(this).parents('.interactiveMap').find('.slider__interactiveMap__images');
			getSlider.slick('slickGoTo',getIndex);
			$('.slider__interactiveMap__nav button').removeClass('text-brand font-bold');
			$(this).addClass('text-brand font-bold');
		});
	  $(this).slick(sliderInteractiveMapImagesSettings);
	});

});